import BaseDrawingObject from "./baseDrawingObject";

class HitchLoad extends BaseDrawingObject {
    constructor(xOffset, yOffset, text) {
        super();
        this.centre = { x: xOffset, y: yOffset };
        this.text = text;
        
        this.type = 'hitchLoad';

        this.drawingGroupName = 'NOT_SET';
        // this.setDrawingGroupName = function (newValue) {
        //     this.drawingGroupName = newValue;
        // }
    }
}



export default HitchLoad;

       